import React, { useEffect } from 'react';
import { Col, Row } from 'reactstrap';
import { connect } from 'react-redux'

import { showLoader } from "../../../components/loader/loader";
import NewItem from "../../../components/buttons/newItem";
import TerminalList from "./_list";
import TerminalForm from "./_form";
import {setApp, clearState} from "../../../redux/actions/generalActions/mainActions";
import {setFilter} from "../../../redux/actions/generalActions/listActions";
import {ButtonSync} from "../../../components/buttons/buttonsActions";
import {syncFirebase} from "../../../redux/actions/hotel/terminalActions";

const AirTerminal = props => {
    const { viewMode, loading } = props.mainProps

    useEffect(() => {
        return () => {
            props.clearState();
            props.setFilter({});
        }
    }, []);

    useEffect(() => {
        if (props.app !== null)
            props.setApp(props.app);
    },[ ]);

    const syncFirebase = () => {
        if (props.app !== null) {
            const dataRequest = {
                fbDataBase: { id:  props.mainProps?.app?.fbDataBase?.id },
            }

            props.syncFirebase(dataRequest);
        }
    }

    return (
        <>
            { loading ? showLoader() : null}
            <div className="ml-auto paddingAdd">
                <ButtonSync onClick={syncFirebase}/>
            </div>
            <NewItem />
            <Row>
                <Col md="12">
                    {(
                        function() {
                            switch (viewMode) {
                                case "LIST" :
                                    return <TerminalList />
                                case "FORM" :
                                    return <TerminalForm />
                                default:
                                    return null;
                            }
                        })()}
                </Col>
            </Row>
        </>
    );
}

const mapStateToProps = state => ({
    mainProps : state.mainProps
});

const mapActionsToProps = ({
    clearState,
    setFilter,
    setApp,
    syncFirebase
});

export default connect(mapStateToProps, mapActionsToProps)(AirTerminal)